import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import {
  Button,
  TextField,
  FormControlLabel,
  Checkbox,
  CircularProgress,
  makeStyles,
  MuiThemeProvider,
  createMuiTheme,
} from "@material-ui/core";
import { useHistory, useParams } from "react-router-dom";
import { deleteTag, getTagById, postTag, updateTag } from "../../../../api/tag";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { Autocomplete } from "@material-ui/lab";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import MultilanguageTabBlock from "../../../components/MultilanguageTabBlock";
import { generateFriendlyUrl } from "../../../../utils/helpers";

const theme = createMuiTheme({
  palette: {
    secondary: {
      main: "#F64E60",
    },
  },
});

const useStyles = makeStyles(() => ({
  dialogContent: {
    padding: 0,
    overflow: "hidden",
  },
  fancyLoader: {
    color: "#AF9A51 ",
    animation: `$spin 1s linear infinite`,
  },
  "@keyframes spin": {
    "0%": {
      transform: "rotate(0deg)",
    },
    "100%": {
      transform: "rotate(360deg)",
    },
  },
}));
function removeAccents(str) {
  return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

export default function EditTagPage() {
  const [tag, setTag] = useState({
    active: true,
    nombre: "",
  });
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const tagId = useParams().id;
  const classes = useStyles();
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        if (tagId) {
          getTagById(tagId)
            .then((resTag) => {
              if (resTag.status === 200) {
                setTag(resTag.data);
              }
            })
            .catch((error) => {
              setLoading(false);
              alertError({
                error,
                customMessage: "Could not get tag details.",
              });
              history.push("/tags");
            });
        }
      } catch (error) {
        setLoading(false);
        alertError({ error: error });
      }
    };

    fetchData();
    setLoading(false);
  }, [tagId, history]);

  const handleChange = (element, lang) => (event) => {
    if (lang) {
      if (event.target.value === " ") return;

      if (!tag[element]) tag[element] = {};
      let newText = tag[element];
      newText[lang] = event.target.value;

      // Si se está editando el título, actualizar automáticamente el enlace
      if (element === "name") {
        if (!tag.enlace) tag.enlace = {};
        tag.enlace[lang] = generateFriendlyUrl(event.target.value);
      }

      setTag({ ...tag, [element]: newText });
    } else setTag({ ...tag, [element]: event.target.value });
  };

  const handleSave = () => {
    if (!tagId) {
      postTag(tag)
        .then(() => {
          alertSuccess({
            title: "Saved!",
            customMessage: "Tag saved successfully.",
          });
          history.push("/tags");
        })
        .catch((error) => {
          alertError({
            error,
            customMessage: "Could not save tag details.",
          });
        });
    } else {
      updateTag(tagId, tag)
        .then(() => {
          alertSuccess({
            title: "Saved!",
            customMessage: "Tag saved successfully.",
          });
          history.push("/tags");
        })
        .catch((error) => {
          alertError({
            error,
            customMessage: "Could not save tag details.",
          });
        });
    }
  };

  const renderMultilanguageTabContent = (lang) => {
    return (
      <div className="row d-flex align-items-center">
        <div className="col-md-6">
          <TextField
            label="Nombre"
            value={tag.name ? tag.name[lang] : ""}
            onChange={handleChange("name", lang)}
            fullWidth
            margin="normal"
            variant="outlined"
            required
          />
        </div>
        <div className="col-md-6">
          <TextField
            label="Url amigable"
            value={tag.enlace ? tag.enlace[lang] : ""}
            onChange={handleChange("enlace", lang)}
            fullWidth
            margin="normal"
            variant="outlined"
            required
          />
        </div>
      </div>
    );
  };
  const renderContentDatosGenerales = () => {
    return (
      <>
        <MultilanguageTabBlock
          multilanguageTabContent={renderMultilanguageTabContent}
        />
      </>
    );
  };
  return (
    <>
      <Card>
        <CardHeader title="Edit Tag" />
        {loading ? (
          <div className="d-flex justify-content-center align-items-center">
            <CircularProgress className={classes.fancyLoader} />
          </div>
        ) : (
          <CardBody>
            {renderContentDatosGenerales()}
            <br />
            <br />
            <FormControlLabel
              control={
                <Checkbox
                  checked={tag.active}
                  onChange={() => setTag({ ...tag, active: !tag.active })}
                />
              }
              label="Active"
            />
          </CardBody>
        )}
      </Card>
      <Button
        onClick={() => history.push("/tags")}
        variant="outlined"
        style={{ marginRight: "20px" }}
      >
        Back
      </Button>
      <Button
        onClick={handleSave}
        variant="outlined"
        color="primary"
        style={{ marginRight: "20px" }}
      >
        Save
      </Button>
      {tagId && (
        <>
          <MuiThemeProvider theme={theme}>
            <Button
              onClick={() => setOpenConfirmDialog(true)}
              variant="outlined"
              color="secondary"
            >
              Delete
            </Button>
          </MuiThemeProvider>

          <ConfirmDialog
            title={"Are you sure you want to delete this watch?"}
            open={openConfirmDialog}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              deleteTag(tagId, tag)
                .then((res) => {
                  if (res.status === 200) {
                    alertSuccess({
                      title: "Deleted!",
                      customMessage: "Delete successfully.",
                    });
                    history.push("/tags");
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: "Could not save changes.",
                  });
                });
            }}
          />
        </>
      )}
    </>
  );
}
